// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2eazt","containerItemsCenter":"Skeleton_containerItemsCenter__2JAwt"};